import { BaseLogger } from '@wix/fedops-logger';
import React, { PropsWithChildren } from 'react';

import { FedopsLoggerContext } from './FedopsLoggerContext';

type FedopsLoggerProviderProps = PropsWithChildren<{
  logger: BaseLogger<string>;
}>;

export function FedopsLoggerProvider({ logger, children }: FedopsLoggerProviderProps) {
  return <FedopsLoggerContext.Provider value={logger}>{children}</FedopsLoggerContext.Provider>;
}
